const ArticleListItem = () => import('../../components/article-list-item/index.vue');
const RecoveryShimmer = () => import('../../components/shimmers-screen/recovery-screen-shimmer.vue');

export default {
    name: 'RecoveryPage',
    
    components: {
        'list-item': ArticleListItem,
        'recovery-shimmer': RecoveryShimmer
    },

    data (){
        return {
            isLoading: true
        };
    },

    computed: {
        list() {
            return this.$store.getters.getArticleList(10002);
        }
    },

    watch: {
    list(val) {
      if (val && val.length) {
        this.isLoading = false;
      }
    }
  },
   
 async created() {
  this.isLoading = true;

  await this.$store.dispatch('fetchArticles');

   this.$store.commit('setMenuItems', this.list);
        this.$store.commit('setMenuDetails', { title: 'Recovery', slug: 'recovery', back_url: '/action/operations' });

  this.isLoading = false;
}
};
